import React from "react";
import { Card, Modal } from "semantic-ui-react";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { isMobile } from "utils/isMobile";
import { formatPhoneNumberToInternational } from "utils/phone";
import { capitalize } from "utils/patientConverter";

const styles = {
	column: {
		fontSize: 25,
		paddingBottom: 25,
	},
	big: {
		fontWeight: "bold",
	},
};

const GranteeModal = ({ open, close, patient }) => {
	return (
		<Modal open={open} onClose={close} closeOnEscape closeOnDimmerClick>
			<Modal.Header>Tuteur(s) - Personne(s) qui ont accès aux résultats</Modal.Header>
			<Modal.Content>
				<Card.Group itemsPerRow={3}>
					{patient.grantees
						.filter((g) => g.grantee)
						.map((g, index) => (
							<Card key={`${index}-${g.id}`}>
								<Card.Content>
									<Card.Header>
										{g.grantee.last_name?.toUpperCase() ?? g.grantee.birth_name?.toUpperCase()} {capitalize(g.grantee.first_name)}
									</Card.Header>
									<Card.Meta>{g.relation}</Card.Meta>
									<Card.Description>
										<div>
											<span style={styles.big}>E-mail : </span>
											{g.grantee.email || "Non renseigné"}
										</div>
										<div>
											<span style={styles.big}>Portable : </span>
											{g.grantee.mobile_phone ? formatPhoneNumberToInternational(g.grantee.mobile_phone) : "Non renseigné"}
										</div>
									</Card.Description>
								</Card.Content>
							</Card>
						))}
				</Card.Group>
			</Modal.Content>
			<Modal.Actions>
				<SecondaryButton onClick={close} style={{ margin: isMobile() ? "-14px .25em 5px 0" : "-0 .25em 0 0" }}>
					Fermer
				</SecondaryButton>
			</Modal.Actions>
		</Modal>
	);
};

export default GranteeModal;
